/* ============================================================
   PickleballDoor — global theme JS
   ============================================================ */
(function () {
  'use strict';

  var routes = window.routes || {};

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var fmt = window.moneyFormat || '${{amount}}';
    // Basic amount replacement; Shopify money_format handles symbol/placement.
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = withCommas + '.' + parts[1];
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, amount)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withCommas)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount);
  }

  /* ---------- Drawer open/close ---------- */
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(el) {
    var d = el.closest ? el.closest('.drawer') : el;
    if (!d) return;
    d.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) { e.preventDefault(); openDrawer(openBtn.getAttribute('data-drawer-open')); return; }
    var closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) { e.preventDefault(); closeDrawer(closeBtn); return; }
    if (e.target.classList && e.target.classList.contains('drawer__overlay')) { closeDrawer(e.target); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
      document.body.style.overflow = '';
      var sp = document.querySelector('[data-search-pop].is-open');
      if (sp) sp.classList.remove('is-open');
    }
  });

  /* ---------- Search popover bubble ---------- */
  document.addEventListener('click', function (e) {
    var pop = document.querySelector('[data-search-pop]');
    if (!pop) return;
    if (e.target.closest('[data-search-toggle]')) {
      e.preventDefault();
      var opened = pop.classList.toggle('is-open');
      if (opened) { var inp = pop.querySelector('input'); if (inp) setTimeout(function () { inp.focus(); }, 40); }
      return;
    }
    if (pop.classList.contains('is-open') && !e.target.closest('.header-search-wrap')) {
      pop.classList.remove('is-open');
    }
  });

  /* ---------- Origin buttons: radial fill grows from the pointer ---------- */
  document.querySelectorAll('.btn:not([data-add-to-cart])').forEach(function (btn) {
    var setOrigin = function (x, y) {
      var r = btn.getBoundingClientRect();
      var cover = 2 * Math.max(
        Math.hypot(x, y),
        Math.hypot(r.width - x, y),
        Math.hypot(x, r.height - y),
        Math.hypot(r.width - x, r.height - y)
      );
      btn.style.setProperty('--ox', x + 'px');
      btn.style.setProperty('--oy', y + 'px');
      btn.style.setProperty('--cover', cover + 'px');
    };
    btn.addEventListener('pointerenter', function (e) {
      var r = btn.getBoundingClientRect();
      setOrigin(e.clientX - r.left, e.clientY - r.top);
    });
    btn.addEventListener('focus', function () {
      var r = btn.getBoundingClientRect();
      setOrigin(r.width / 2, r.height / 2);
    });
  });

  /* ---------- Theme editor: a section that reloads must re-run its effects ----------
     Fixes reveal-animated tiles staying invisible (looking all-black) after editing. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target || document;
    // instantly reveal scroll-in elements inside the reloaded section
    root.querySelectorAll('.u-reveal').forEach(function (el) { el.classList.add('u-in'); });
    // re-register parallax targets rendered by the reloaded section
    collectParallax(root);
    updateParallax();
    initCatCarousel(root);
    // re-wire origin-button fill for the fresh buttons
    root.querySelectorAll('.btn:not([data-add-to-cart])').forEach(function (btn) {
      if (btn.getAttribute('data-origin-init')) return;
      btn.setAttribute('data-origin-init', '1');
      btn.addEventListener('pointerenter', function (ev) {
        var r = btn.getBoundingClientRect();
        var x = ev.clientX - r.left, y = ev.clientY - r.top;
        var cover = 2 * Math.max(Math.hypot(x, y), Math.hypot(r.width - x, y), Math.hypot(x, r.height - y), Math.hypot(r.width - x, r.height - y));
        btn.style.setProperty('--ox', x + 'px');
        btn.style.setProperty('--oy', y + 'px');
        btn.style.setProperty('--cover', cover + 'px');
      });
    });
  });

  /* ---------- Category carousel: arrows swap the slide, the CTA follows it ---------- */
  function initCatCarousel(root) {
    (root || document).querySelectorAll('[data-cat-carousel]').forEach(function (box) {
      if (box.getAttribute('data-cat-init')) return;
      box.setAttribute('data-cat-init', '1');
      var slides = [].slice.call(box.querySelectorAll('[data-cat-slide]'));
      if (slides.length < 2) return;
      var cta = box.querySelector('[data-cat-cta]');
      var i = 0;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        if (cta) {
          cta.setAttribute('href', slides[i].getAttribute('data-url') || '#');
          cta.textContent = slides[i].getAttribute('data-cta') || '';
        }
      }
      var prev = box.querySelector('[data-cat-prev]');
      var next = box.querySelector('[data-cat-next]');
      if (prev) prev.addEventListener('click', function () { show(i - 1); });
      if (next) next.addEventListener('click', function () { show(i + 1); });
      show(0);
    });
  }
  initCatCarousel(document);

  /* ---------- Parallax "suspension": the image drifts slower than the scroll ---------- */
  var parallaxEls = [];
  var parallaxTick = false;
  function collectParallax(root) {
    (root || document).querySelectorAll('[data-parallax]').forEach(function (el) {
      if (parallaxEls.indexOf(el) === -1) parallaxEls.push(el);
    });
  }
  function updateParallax() {
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -300 || r.top > vh + 300) return;
      var amount = parseFloat(el.getAttribute('data-parallax')) || 40;
      // -1 while the block is still below the fold, +1 once it has scrolled past the top
      var progress = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2);
      progress = Math.max(-1, Math.min(1, progress));
      el.style.setProperty('--m-ty', (progress * amount).toFixed(1) + 'px');
    });
    parallaxTick = false;
  }
  function onParallaxScroll() {
    if (!parallaxTick) { parallaxTick = true; requestAnimationFrame(updateParallax); }
  }
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    collectParallax(document);
    window.addEventListener('scroll', onParallaxScroll, { passive: true });
    window.addEventListener('resize', onParallaxScroll);
    updateParallax();
  }

  /* ---------- Hand-drawn squiggle underlines (day one style) ----------
     Shapes cycle globally: every hover anywhere uses the NEXT squiggle,
     so shapes are not tied to a specific menu item. */
  var SQUIGGLES = [
    // gentle wave
    'M2 9 Q12 3 24 8 T46 8 T68 8 T90 8 T118 7',
    // sharp zigzag
    'M2 11 L14 4 L26 11 L38 4 L50 11 L62 4 L74 11 L86 4 L98 11 L110 4 L118 9',
    // relaxed double stroke
    'M2 6 C40 3 80 3 118 5 M8 11 C46 8 84 8 112 10',
    // loopy scribble
    'M2 10 C20 2 34 2 30 9 C26 15 44 12 58 8 C76 3 82 4 78 10 C74 15 96 12 118 6'
  ];
  var sqIndex = 0;
  var SVG_NS = 'http://www.w3.org/2000/svg';
  function attachSquiggle(el) {
    el.classList.add('has-squiggle');
    el.addEventListener('mouseenter', function () {
      var svg = el.querySelector('.squiggle');
      if (!svg) {
        svg = document.createElementNS(SVG_NS, 'svg');
        svg.setAttribute('class', 'squiggle');
        svg.setAttribute('viewBox', '0 0 120 14');
        svg.setAttribute('preserveAspectRatio', 'none');
        svg.setAttribute('aria-hidden', 'true');
        var p = document.createElementNS(SVG_NS, 'path');
        p.setAttribute('fill', 'none');
        p.setAttribute('stroke', 'currentColor');
        p.setAttribute('stroke-width', '2.6');
        p.setAttribute('stroke-linecap', 'round');
        p.setAttribute('stroke-linejoin', 'round');
        p.setAttribute('pathLength', '1');
        svg.appendChild(p);
        el.appendChild(svg);
      }
      svg.querySelector('path').setAttribute('d', SQUIGGLES[sqIndex++ % SQUIGGLES.length]);
      svg.classList.remove('drawn');
      void svg.getBoundingClientRect();
      svg.classList.add('drawn');
      el.classList.add('sq-on');
    });
    el.addEventListener('mouseleave', function () { el.classList.remove('sq-on'); });
  }
  document.querySelectorAll('.site-header__nav .nav-link').forEach(attachSquiggle);

  /* ---------- Shop mega-menu (hover to reveal sub-collections) ---------- */
  document.querySelectorAll('[data-shop-cats]').forEach(function (cats) {
    var panels = cats.parentElement.querySelector('[data-shop-panels]');
    function activate(i) {
      cats.querySelectorAll('[data-cat]').forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-cat') === i);
      });
      if (panels) panels.querySelectorAll('[data-panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-panel') === i);
      });
    }
    cats.querySelectorAll('[data-cat]').forEach(function (c) {
      var i = c.getAttribute('data-cat');
      c.addEventListener('mouseenter', function () { activate(i); });
      c.addEventListener('focus', function () { activate(i); });
      c.addEventListener('click', function () { activate(i); });
    });
    var first = cats.querySelector('[data-cat]');
    if (first) activate(first.getAttribute('data-cat'));
  });

  /* ---------- Cart (AJAX) ---------- */
  function getCart() {
    return fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function renderCart(cart) {
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      if (el.classList.contains('cart-count-badge')) el.classList.toggle('is-empty', cart.item_count === 0);
    });

    var itemsEl = document.querySelector('[data-cart-items]');
    var titleEl = document.querySelector('[data-cart-title]');
    if (titleEl) titleEl.textContent = 'Your Cart (' + cart.item_count + ')';

    if (itemsEl) {
      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div style="padding:60px 26px;text-align:center;color:#8B8781;">' +
          '<div style="font-size:16px;font-weight:600;margin-bottom:16px;">Your cart is empty</div>' +
          '<a href="' + (window.shopRoutes && window.shopRoutes.all ? window.shopRoutes.all : '/collections/all') + '" class="u-btn" style="display:inline-flex;background:#0A0A0A;color:#fff;font-weight:700;font-size:14px;padding:13px 26px;border-radius:999px;">Shop now</a>' +
          '</div>';
      } else {
        itemsEl.innerHTML = cart.items.map(function (item) {
          var img = item.image ? '<img src="' + item.image.replace('.jpg', '_160x.jpg') + '" alt="' + escapeHtml(item.product_title) + '">' : '';
          var opts = (item.options_with_values || []).map(function (o) { return o.value; }).join(' · ');
          return '<div class="cart-line" data-line-key="' + item.key + '">' +
            '<div class="cart-line__media">' + img + '</div>' +
            '<div style="flex:1;">' +
              '<div style="display:flex;justify-content:space-between;gap:10px;">' +
                '<span style="font-weight:700;font-size:15px;">' + escapeHtml(item.product_title) + '</span>' +
                '<span style="font-weight:700;font-size:15px;">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
              (opts ? '<div style="font-size:13px;color:#8B8781;margin-top:4px;">' + escapeHtml(opts) + '</div>' : '') +
              '<div style="display:flex;align-items:center;gap:12px;margin-top:10px;">' +
                '<div style="display:flex;align-items:center;border:1px solid #E7E4DD;border-radius:999px;">' +
                  '<button class="u-btn" data-qty-down style="background:none;padding:4px 12px;font-size:16px;cursor:pointer;">−</button>' +
                  '<span style="min-width:22px;text-align:center;font-size:14px;font-weight:700;">' + item.quantity + '</span>' +
                  '<button class="u-btn" data-qty-up style="background:none;padding:4px 12px;font-size:16px;cursor:pointer;">+</button>' +
                '</div>' +
                '<button class="u-under" data-line-remove style="cursor:pointer;font-size:13px;color:#8B8781;background:none;border:none;">Remove</button>' +
              '</div>' +
            '</div>' +
          '</div>';
        }).join('');
      }
    }

    var subEl = document.querySelector('[data-cart-subtotal]');
    if (subEl) subEl.textContent = formatMoney(cart.total_price);

  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function addToCart(id, quantity, extra) {
    var body = { id: id, quantity: quantity || 1 };
    if (extra) Object.assign(body, extra);
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); })
      .then(function () { return getCart(); })
      .then(function (cart) { renderCart(cart); openDrawer('CartDrawer'); return cart; });
  }

  function changeLine(key, quantity) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  // add-to-cart buttons (product forms + upsell)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('form');
    var variantId = btn.getAttribute('data-variant-id');
    if (form) {
      var sel = form.querySelector('[name="id"]');
      if (sel && sel.value) variantId = sel.value;
    }
    if (!variantId) return;
    btn.setAttribute('disabled', 'disabled');
    var original = btn.textContent;
    btn.textContent = 'Adding…';
    addToCart(variantId, 1).then(function () {
      btn.removeAttribute('disabled');
      btn.textContent = original;
    }).catch(function () {
      btn.removeAttribute('disabled');
      btn.textContent = original;
    });
  });

  // cart line qty / remove (event delegation)
  document.addEventListener('click', function (e) {
    var line = e.target.closest('[data-line-key]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var qtySpan = line.querySelector('span[style*="text-align:center"]');
    var current = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
    if (e.target.closest('[data-qty-up]')) { changeLine(key, current + 1); }
    else if (e.target.closest('[data-qty-down]')) { changeLine(key, Math.max(0, current - 1)); }
    else if (e.target.closest('[data-line-remove]')) { changeLine(key, 0); }
  });

  /* ---------- Product variant selection ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var selected = {};
    // initialize from active variant
    var idInput = form.querySelector('[name="id"]');

    function currentOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var active = group.querySelector('.is-active');
        opts[idx] = active ? active.getAttribute('data-value') : null;
      });
      return opts;
    }

    function matchVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (o, i) { return o == null || v.options[i] === o; });
      });
    }

    function updateVariant() {
      var opts = currentOptions();
      var v = matchVariant(opts) || variants[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      var priceEl = form.querySelector('[data-price]');
      var compareEl = form.querySelector('[data-compare]');
      var addBtn = form.querySelector('[data-add-to-cart]');
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.style.display = '';
          compareEl.textContent = formatMoney(v.compare_at_price);
        } else { compareEl.style.display = 'none'; }
      }
      var labelEls = form.querySelectorAll('[data-selected-option]');
      labelEls.forEach(function (le) {
        var i = parseInt(le.getAttribute('data-selected-option'), 10);
        le.textContent = v.options[i] || '';
      });
      // swap the main gallery image to the selected variant's image
      if (v.image) {
        var mainImg = document.querySelector('[data-gallery-main] img');
        if (mainImg) {
          // srcset would override src, so drop it once we swap to a chosen image
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.setAttribute('src', v.image);
          document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
            t.classList.toggle('is-active', t.getAttribute('data-full') === v.image);
          });
        }
      }
      if (addBtn) {
        var priceInBtn = addBtn.querySelector('[data-btn-price]');
        if (v.available) {
          addBtn.removeAttribute('disabled');
          addBtn.setAttribute('data-variant-id', v.id);
          if (priceInBtn) priceInBtn.textContent = formatMoney(v.price);
          else addBtn.textContent = addBtn.getAttribute('data-label') || 'Add to cart';
        } else {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.textContent = 'Sold out';
        }
      }
    }

    form.querySelectorAll('[data-option-index]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var choice = e.target.closest('[data-value]');
        if (!choice) return;
        group.querySelectorAll('[data-value]').forEach(function (c) { c.classList.remove('is-active'); });
        choice.classList.add('is-active');
        updateVariant();
      });
    });
    updateVariant();
  });

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (mainImg && src) {
          // srcset would override src, so drop it once the shopper picks a thumb
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.setAttribute('src', src);
        }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Accordions ---------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.accordion__head');
    if (!head) return;
    var acc = head.closest('.accordion');
    var sign = head.querySelector('.accordion__sign');
    var isOpen = acc.classList.toggle('is-open');
    if (sign) sign.textContent = isOpen ? '–' : '+';
  });

  /* ---------- Reveal on scroll ---------- */
  var revealEls = document.querySelectorAll('.u-reveal');
  if (revealEls.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('u-in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('u-in'); });
    }
  }

  /* ---------- Door wordmark handwriting draw-in ---------- */
  var doorEl = document.querySelector('[data-door]');
  if (doorEl) {
    var playDoor = function () { doorEl.classList.remove('draw'); void doorEl.offsetWidth; doorEl.classList.add('draw'); };
    // draw once fonts are ready so the script glyphs are measured correctly
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(playDoor); } else { playDoor(); }
    if ('IntersectionObserver' in window) {
      var doorIn = true;
      new IntersectionObserver(function (entries) {
        var on = entries[entries.length - 1].isIntersecting;
        if (on) { if (!doorIn) { doorIn = true; playDoor(); } } else { doorIn = false; }
      }, { threshold: 0.5 }).observe(doorEl);
    }
  }

  /* ---------- 3D / Film toggle ---------- */
  var viewer = document.querySelector('[data-viewer]');
  if (viewer) {
    var openFilmBtn = document.querySelector('[data-open-film]');
    var closeFilmBtn = viewer.querySelector('[data-close-film]');
    var stage3d = viewer.querySelector('[data-stage-3d]');
    var stageFilm = viewer.querySelector('[data-stage-film]');
    var badge = viewer.querySelector('[data-viewer-badge]');
    var dragHint = viewer.querySelector('[data-3d-only]');
    function setFilm(on) {
      if (stage3d) stage3d.style.display = on ? 'none' : 'flex';
      if (stageFilm) stageFilm.style.display = on ? 'flex' : 'none';
      if (closeFilmBtn) closeFilmBtn.style.display = on ? '' : 'none';
      if (dragHint) dragHint.style.display = on ? 'none' : '';
      if (badge) badge.textContent = on ? (badge.getAttribute('data-film-label') || 'FILM') : (badge.getAttribute('data-3d-label') || '3D VIEW');
    }
    if (openFilmBtn) openFilmBtn.addEventListener('click', function () { setFilm(true); });
    if (closeFilmBtn) closeFilmBtn.addEventListener('click', function () { setFilm(false); });
    setFilm(false);
  }

  /* ---------- Sticky buy bar (product) ---------- */
  var buyBar = document.querySelector('[data-buy-bar]');
  var buyAnchor = document.querySelector('[data-buy-anchor]');
  if (buyBar && buyAnchor) {
    var onScroll = function () {
      var r = buyAnchor.getBoundingClientRect();
      if (r.bottom < 10) buyBar.classList.add('is-visible');
      else buyBar.classList.remove('is-visible');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Hero video ---------- */
  var heroVideo = document.querySelector('[data-hero-video]');
  if (heroVideo) {
    heroVideo.muted = true; heroVideo.loop = true; heroVideo.playsInline = true;
    heroVideo.setAttribute('playsinline', '');
    // start once the black intro has faded, so the opening of the film is not hidden behind it
    var startHero = function () { heroVideo.currentTime = 0; var pr = heroVideo.play(); if (pr && pr.catch) pr.catch(function () {}); };
    var heroIntro = document.querySelector('[data-hero-intro]');
    if (heroIntro && getComputedStyle(heroIntro).animationName !== 'none') setTimeout(startHero, 2300);
    else startHero();
    heroVideo.addEventListener('error', function () { heroVideo.style.display = 'none'; });
  }

  /* ---------- Transparent header overlay offset ---------- */
  function applyOverlay() {
    var th = document.querySelector('.site-header--transparent');
    if (!th) return;
    document.body.classList.add('has-transparent-header');
    document.documentElement.style.setProperty('--overlay-offset', (-th.offsetHeight) + 'px');
  }
  applyOverlay();
  window.addEventListener('resize', applyOverlay, { passive: true });

  /* ---------- Sticky header: pin the section wrapper + frosted state on scroll ---------- */
  var siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    // pin the shopify-section wrapper (its containing block is <body>, so it stays pinned page-wide)
    var headerWrap = siteHeader.closest('.shopify-section') || siteHeader.parentElement;
    if (headerWrap) headerWrap.setAttribute('data-sticky-header', '');
    var onHeaderScroll = function () {
      if (window.scrollY > 60) siteHeader.classList.add('is-scrolled');
      else siteHeader.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  // refresh cart count on load
  getCart().then(renderCart).catch(function () {});
})();
